export default "__VITE_ASSET__CLfpD2aK__"